import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { InspectionAttachments } from './InspectionAttachments';
import './InspectionAttachmentsStyles.scss';
const queryClient = new QueryClient();
function InspectionAttachmentsIndex(props) {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(InspectionAttachments, Object.assign({}, props))));
}
export default InspectionAttachmentsIndex;
